import script from "./SavedToSpendStatCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavedToSpendStatCard.vue?vue&type=script&setup=true&lang=ts"

import "./SavedToSpendStatCard.vue?vue&type=style&index=0&id=76699309&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76699309"]])

export default __exports__